<template>
	<div class="w1200 addresDetal">
		<choice-menu></choice-menu>
		<div class="flex flex-direction align-stretch benben-flex-layout myinfo_1">
			<div class="flex addresDetal_1">
				<div class="flex benben-flex-layout flex-wrap align-center pointer " @click="caozuo(1)">
					<img class="addresDetal_1_1" src="https://api.ezlunch.club/pc/image/13.png" alt="" srcset="">
					<div class="addresDetal_1_2">{{$t('返回')}}</div>
				</div>
			</div>
			<div class="flex benben-flex-layout flex-wrap align-center addresDetal_2">
				<div class="addresDetal_2_1">{{$t('收货地址')}}</div>
				<img class="addresDetal_2_2" src="https://api.ezlunch.club/pc/image/13.png" alt="" srcset="">
				<div class="addresDetal_2_3">{{$t('添加地址')}}</div>
			</div>
			<div class="addresDetal_3">
				<div class="flex benben-flex-layout flex-wrap align-center addresDetal_3_0" @click="drawer5 = true">
					<div class="addresDetal_3_1">{{$t('选择地址')}}</div>
					<div class="flex benben-flex-layout flex-wrap align-center pointer addresDetal_3_2" v-if="!input6">
						<div class="flex-sub addresDetal_3_3">{{$t('请选择')}}</div>
						<img class="addresDetal_3_4" src="https://api.ezlunch.club/pc/image/35.png" alt="" srcset="">
					</div>
					<div class="flex benben-flex-layout flex-wrap align-center pointer addresDetal_3_2" v-else>
						<div class="addresDetal_4_4">{{input6}}</div>
						<img class="addresDetal_4_3" src="https://api.ezlunch.club/pc/image/37.png" alt="" srcset="">
					</div>
				</div>
				<div class="flex benben-flex-layout flex-wrap align-center addresDetal_3_0">
					<div class="addresDetal_3_1">{{$t('联系人')}}</div>
					<div class="flex benben-flex-layout flex-wrap align-center pointer addresDetal_3_9">
						<el-input class="flex-sub addresDetal_3_8" v-model="input1" :placeholder="$t('请输入联系人')"></el-input>
					    <div class="flex">
					    	<div class="flex benben-flex-layout flex-wrap align-center pointer" @click="input2 = 1">
								<img class="addresDetal_3_5" v-if="input2 == 1" src="https://api.ezlunch.club/pc/image/36.png" alt="" srcset="">
								<img class="addresDetal_3_5" v-else src="https://api.ezlunch.club/pc/image/9.png" alt="" srcset="">
								<div class="addresDetal_3_6">{{$t('先生')}}</div>
							</div>
							<div class="flex benben-flex-layout flex-wrap align-center pointer" @click="input2 = 2">
								<img class="addresDetal_3_5" v-if="input2 == 2" src="https://api.ezlunch.club/pc/image/36.png" alt="" srcset="">
								<img class="addresDetal_3_5" v-else src="https://api.ezlunch.club/pc/image/9.png" alt="" srcset="">
								<div class="addresDetal_3_7">{{$t('女士')}}</div>
							</div>
					    </div>
					</div>
				</div>
				<div class="flex benben-flex-layout flex-wrap align-center addresDetal_3_0">
					<div class="addresDetal_3_1">{{$t('联系电话')}}</div>
					<div class="flex benben-flex-layout flex-wrap align-center pointer addresDetal_3_9">
						<!-- <div class="login_7_2">+1</div> -->
						<el-select class="elSelect" v-model="qu_id" placeholder="请选择">
						    <el-option
						      v-for="item in qu_list"
						      :key="item.value"
						      :label="item.label"
						      :value="item.value">
						    </el-option>
						  </el-select>
						<el-input class="flex-sub addresDetal_3_8" v-model="input3" :placeholder="$t('请输入手机号')"></el-input>
					</div>
				</div>
				<div class="flex benben-flex-layout flex-wrap align-center addresDetal_3_0">
					<div class="addresDetal_3_1">{{$t('门牌号')}}</div>
					<div class="flex benben-flex-layout flex-wrap align-center pointer addresDetal_3_9">
						<el-input class="flex-sub addresDetal_3_8" v-model="input7" :placeholder="$t('请输入门牌号')"></el-input>
					</div>
				</div>
				
				<div class="flex benben-flex-layout flex-wrap align-center addresDetal_3_0">
					<div class="addresDetal_3_1">{{$t('街道名称')}}</div>
					<div class="flex benben-flex-layout flex-wrap align-center pointer addresDetal_3_9">
						<el-input class="flex-sub addresDetal_3_8" v-model="input8" :placeholder="$t('请输入街道名称')"></el-input>
					</div>
				</div>
				<div class="flex benben-flex-layout flex-wrap align-center addresDetal_3_0">
					<div class="addresDetal_3_1">{{$t('州邮编')}}</div>
					<div class="flex benben-flex-layout flex-wrap align-center pointer addresDetal_3_9">
						<el-input class="flex-sub addresDetal_3_8" v-model="input9" :placeholder="$t('请输入州邮编 ')"></el-input>
					</div>
				</div>
				
				<!-- <div class="flex benben-flex-layout flex-wrap align-center addresDetal_3_0">
					<div class="addresDetal_3_1">{{$t('详细地址')}}</div>
					<el-input class="addresDetal_4" type="textarea" :placeholder="$t('请输入详细地址，以便师傅配送')" resize="none" maxlength="300" show-word-limit v-model="input4"></el-input>
				</div> -->
				<div class="flex benben-flex-layout flex-wrap align-center addresDetal_3_0">
					<div class="addresDetal_3_1">{{$t('设置默认地址')}}</div>
					<el-switch
					  class="addresDetal_4_1"
					  v-model="input5"
					  active-color="#13ce66">
					</el-switch>
				</div>
			</div>
			<div class="addresDetal_4_2 pointer" @click="tijiao">{{$t('确定')}}</div>
		</div>
		<amap :positionDialog.sync="drawer5"  @selPosition="dizhi">
		</amap>
		
	
		
	</div>
</template>

<script>
	import ChoiceMenu from "../components/choiceMenu.vue"
	import Amap from "@/components/amap.vue"
	export default {
		components: {
			ChoiceMenu,Amap
		},
		data() {
			return {
				drawer5:false,
				qu_list:[
					{
					    value: '1',
					    label: '美国（+1）'
					},
					{
					    value: '86',
					    label: '中国（+86）'
					},
				],
				qu_id:'1',
				input1:'',
				input2:1,
				input3:'',
				input4:'',
				input7:'',
				input8:'',
				input9:'',
				input5:true,
				input6:'河南省郑州市二七区华城国际',
				lat: "34.656565",
				lng: "113.65656",
				address_id:'',
			}
		},
		created() {
			if(window.sessionStorage.getItem('token')){
				if(window.sessionStorage.getItem('address_id')){
					this.address_id = window.sessionStorage.getItem('address_id')
					window.sessionStorage.setItem('address_id','');
					this.post636fd7826b3ee()
				}
			}else{
				this.$router.push({
					name: 'login',
				});
			}
			
		},

		methods: {
			dizhi(item){
				if(item.name){
					this.input6 = item.name
				}
				if(item.lat){
					this.lat = item.lat
				}
				if(item.lng){
					this.lng = item.lng
				}
				
				console.log(item,'参数信息')
			},
			gengxin(){
				if(this.address_id){
					this.post636fd7826b3ee()
				}
			},
			// 地址详情
			post636fd7826b3ee(){
				this.$api.get(this.$apiUrls.post636fd7826b3ee,{params: {address_id: this.address_id}}).then((res) => {
					if(res.code == 1){
						let detail = res.data
						this.input6 = detail.address
						this.input1 = detail.real_name
						this.input2 = detail.sex
						this.input3 = detail.mobile
						this.qu_id = detail.area_code
						this.input4 = detail.detail
						this.input5 = detail.is_default == 1 ? true : false
						this.input7 = detail.house_number
						this.input8 = detail.street_name
						this.input9 = detail.state_postal_code
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			tijiao(){
				let url = ''
				let name = ''
				let page = {}
				if(!this.input6){
					this.$message.error(this.$t('请选择地址'));
					return
				}
				if(!this.input1){
					this.$message.error(this.$t('请输入联系人'));
					return
				}
				if(!this.input3){
					this.$message.error(this.$t('请输入手机号'));
					return
				}
				if(!this.input7){
					this.$message.error(this.$t('请输入门牌号'));
					return
				}
				if(!this.input8){
					this.$message.error(this.$t('请输入街道名称'));
					return
				}
				if(!this.input9){
					this.$message.error(this.$t('请输入州邮编'));
					return
				}
				// if(!this.input4){
				// 	this.$message.error(this.$t('请输入详细地址'));
				// 	return
				// }
				if(this.address_id){
					url = this.$apiUrls.post637df1ea39d16
					page = {
						address: this.input6,
						area_code:this.qu_id,
						address_id:this.address_id,
						detail:this.input7 + this.input8 + this.input9,
						is_default: this.input5 ? 1 : '0',
						lat: this.lat,
						lng: this.lng,
						mobile: this.input3,
						real_name: this.input1,
						sex: this.input2,
						house_number:this.input7,
						street_name:this.input8,
						state_postal_code:this.input9,
					}
					name = this.$t('编辑成功')
				}else{
					url = this.$apiUrls.post637defdbd53ef
					page = {
						address: this.input6,
						area_code:this.qu_id,
						detail:this.input7 + this.input8 + this.input9,
						is_default: this.input5 ? 1 : '0',
						lat: this.lat,
						lng: this.lng,
						mobile: this.input3,
						real_name: this.input1,
						sex: this.input2,
						house_number:this.input7,
						street_name:this.input8,
						state_postal_code:this.input9,
					}
					name = this.$t('添加成功')
				}
				
				this.$api.post(url,page).then((res) => {
					if(res.code == 1){
						this.$message.success(name);
						this.ti_type = false
						setTimeout(() => {
							window.history.back();
							return
						}, 1000)
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			caozuo(type,item,index){
				if(type == 1){ //返回上一页
					window.history.back();
					return
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		.addresDetal_3_8{
			.el-input__inner{
				height: 40px;
				border: none;
			}
		}
		.el-textarea__inner{
			width: 444px;
			height: 140px;
			background: #FFFFFF;
			border: none;
		}
		.elSelect{
			.el-input--suffix{
				width: 94px;
			}
			.el-input input{
				width: 94px;
				padding: 0 !important;
			}
			.el-input input {
				
				background: rgba(0, 0, 0, 0);
				border: none;
			}
		}
	}
	.addresDetal{
		padding: 20px 0 0 0;
	}
	.addresDetal_1{
		padding: 21px 0;
		border-bottom: 1px solid #EEEEEE;
	}
	.myinfo_1{
		width: 980px;
		margin: 0 0 0 220px;
		padding:0 20px 100px;
		background: #fff;
		box-sizing: border-box;
	}
	.addresDetal_1_1{
		width: 14px;
		height: 14px;
		
	}
	.addresDetal_1_2{
		font-weight: 400;
		font-size: 16px;
		color: #666666;
		margin-left: 12px;
	}
	.addresDetal_2{
		margin: 16px 0 0 0;
	}
	.addresDetal_2_1{
		font-weight: 400;
		font-size: 16px;
		color: #666666;
	}
	.addresDetal_2_2{
		width: 8px;
		height: 8px;
		margin: 0 10px;
		transform: rotate(180deg);
	}
	.addresDetal_2_3{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.addresDetal_3{
		margin: 24px 0 0 0;
	}
	.addresDetal_3_0{
		margin: 0 0 32px 0;
	}
	.addresDetal_3_1{
		width: 90px;
		text-align: right;
	}
	.addresDetal_3_2{
		width: 446px;
		// height: 44px;
		padding: 12px 10px;
		background: #FFFFFF;
		border-radius: 6px 6px 6px 6px;
		border: 1px solid #DDDDDD;
		margin: 0 0 0 20px;
	}
	.addresDetal_3_9{
		width: 446px;
		height: 44px;
		padding: 0px 10px;
		background: #FFFFFF;
		border-radius: 6px 6px 6px 6px;
		border: 1px solid #DDDDDD;
		margin: 0 0 0 20px;
	}
	.addresDetal_3_3{
		font-weight: 400;
		font-size: 14px;
		color: #666666;
		margin: 0 32px 0 0;
	}
	.addresDetal_3_4{
		width: 18px;
		height: 18px;
	}
	.addresDetal_3_5{
		width: 14px;
		height: 14px;
		margin: 0 8px 0 0;
	}
	.addresDetal_3_6{
		font-weight: 400;
		font-size: 14px;
		color: #221E1F;
		margin: 0 18px 0 0;
	}
	.addresDetal_3_7{
		font-weight: 400;
		font-size: 14px;
		color: #221E1F;
	}
	.addresDetal_4{
		font-size: 16px;
		color: #1A1A1A;
		margin: 0 0 0 20px;
	}
	.addresDetal_4{
		width: 446px;
		height: 142px;
		background: #FFFFFF;
		border-radius: 6px 6px 6px 6px;
		border: 1px solid #DDDDDD;
	}
	.addresDetal_4_1{
		margin: 0 0 0 20px;
	}
	.addresDetal_4_2{
		width: 180px;
		height: 48px;
		background: #FF770F;
		border-radius: 8px 8px 8px 8px;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		line-height: 48px;
		text-align: center;
		margin: 57px 0 0 200px;
	}
	.addresDetal_4_3{
		width: 18px;
		height: 18px;
	}
	.addresDetal_4_4{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
	}
</style>